const explanationTranslations = {
  tabWorkout: " التمارين",
  tabNutirition: " التغذية",
  explainationPopUp: {
    cancel: "اغلاق",
  },
};

export default explanationTranslations;
